var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetch}},[_c('div',{staticClass:"residentials-embed-page"},[(_vm.item.id)?_c('Residentials',{attrs:{"project":_vm.item.id,"properties":_vm.properties}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }